class LoginviaotpRequest{
    constructor(){
       
        this.user_Id = null;
        this.otp = null;
        this.fcmToken = null;
    }
}
export default LoginviaotpRequest;